import { RecoveryApi, ContactOption } from "../interfaces/recoveryApi";

export class RecoveryService {
  constructor(private recoveryApi: RecoveryApi) {}

  async findPatient(tipoDocumento: string, numero: string): Promise<string> {
    return await this.recoveryApi.findPatient(tipoDocumento, numero);
  }

  async getContactOptions(token: string): Promise<ContactOption[]> {
    return await this.recoveryApi.getContactOptions(token);
  }

  async sendCode(token: string, option: number): Promise<string> {
    return await this.recoveryApi.sendCode(token, option);
  }

  async validateCode(token: string, code: string): Promise<string> {
    return await this.recoveryApi.validateCode(token, code);
  }

  async changePassword(token: string, password: string): Promise<void> {
    return await this.recoveryApi.changePassword(token, password);
  }
}
